export const DELAY_SECONDS = 5
